import React from 'react';
import { renderRichText } from 'gatsby-source-contentful/rich-text';

export const RichText = ({ content, options }) => (
  <>{renderRichText(content, options)}</>
);
